import React from "react";
import { useDraggableSheet } from "../../../helpers/hooks";
import './DeleteCreation.scss'
import MediaPlayer from "../MediaPlayer/MediaPlayer";

const DeleteCreation = ({ creation, onClose, onDelete }) => {

    const {
        sheetStyle,
        overlayHandlers,
    } = useDraggableSheet({ onClose })

    const media = (creation || {}).media ? (creation || {}).media : null;

    return (
        <div className="delete-container" {...overlayHandlers}>
            <div className="sheet txt-ac px-16" style={sheetStyle} onClick={(e) => e.stopPropagation()}>
                <p className="fs-sm2 mt-24 mb-16 fg-crea fw-medium-bold">Are you sure you want to delete "{creation?.title}"?</p>
                <div
                    className={`thumbnail-creation ${media?.media_type === "pdf" ? "pdf-thumbnail" : ""}`}
                    key={creation.creation_id}
                >
                    <img
                        src={creation.thumbnail_url || creation.media_url}
                        alt={creation.title || "Creation preview"}
                        className="img-thumbnail"
                    />
                </div>
                
                <p className="fg-hyk-medgrey mt-12 mb-24">Sometimes creativity needs a reset. Just be sure before you let go.</p>
                <button className="btn btn-md red-outline-btn btn-full" onClick={onDelete}>Yes, delete permanently</button>
                <p className="fg-dark fs-xs mt-16 fw-bold" onClick={onClose}>CANCEL</p>
            </div>
        </div>
    )
}

export default DeleteCreation